<template>
<section class="section-4  section">
    <div class="new-inrContent">
        <div class="section-tit-wrap  flex-b--c">
            <h2>추천 고시원</h2>
            <div class="arrowSlider" v-if="kosiwonList.length > 0">
                <span class="prev" id="aro1_prev">prev</span>
                <span class="next" id="aro1_next" style="margin-left:3px;">next</span>
            </div>
        </div>
        <div class="slick-wrapper room-swiper">
            <div id="slick1">
                <li class="slide-item" v-for="(kosiwon, idx) in kosiwonList" :key="'kosiwon_+'+idx" :data-pk="kosiwon.pk">
                    <div class="room-item">
                        <div>
                            <div class="ribon-wrap" v-if="packageTypeCheck(kosiwon.package_type)">
                                <span class="ribon best">
                                    <figure><img src="@/assets/new_images/label-best.png" alt="베스트 리본 이미지"></figure>
                                    <span class="text-indent">Best</span>
                                </span>
                            </div>
                            <figure class="room-item__figure">
                                <img :src="thumbnailCheck(kosiwon.thumbnail_url)" alt="고시원 이미지" style="object-fit:cover;">
                                <span class="heart-wrap heart-includes" @click="heartToggleKosiwon(kosiwon)">
                                    <figure class="heart-active heart-includes" v-if="kosiwon.isHeart">
                                        <img src="@/assets/new_images/icon-heart-active.png" class="heart-includes" alt="하트 기본 이미지">
                                    </figure>
                                    <figure class="heart-empty heart-includes" v-else>
                                        <img src="@/assets/new_images/icon-heart-default.png" class="heart-includes" alt="하트 기본 이미지">
                                    </figure>
                                </span>
                            </figure>
                            <div class="room-txt">
                                <dl>
                                    <dt class="flex-b--c">
                                        <span>{{kosiwon.name}} {{kosiwon.branch}}</span>
                                        <strong class="room-rent">
                                            <div class="font-engNum">{{kosiwon.price_min}}~{{kosiwon.price_max}} </div> 만원 /
                                            <small>월</small>
                                        </strong>
                                    </dt>
                                    <dd>{{kosiwon.intro}}</dd>
                                </dl>
                                <ul class="train-wrap" v-if="kosiwon.traffics_subway.length > 0">
                                    <li class="train-list" v-for="(subway, idx) in kosiwon.traffics_subway" :key="'traffic_'+idx">
                                        <div class="line-circles">
                                            <span class="line-circle subway" :class="getLineClassName(subway.station_number)"></span>
                                        </div>
                                        <span class="line-name">{{subway.intro}}</span>
                                    </li>
                                </ul>
                                <ul class="train-wrap" v-else>
                                    <li class="train-list"></li>
                                </ul>
                                <ul class="hashtag-wrap d-flex">
                                    <li class="hashtag-list" v-if="kosiwon.options.use_sex_type === 'M'">#남성전용</li>
                                    <li class="hashtag-list" v-if="kosiwon.options.use_sex_type === 'W'">#여성전용</li>
                                    <li class="hashtag-list" v-if="kosiwon.options.use_sex_type === 'U'">#남녀공용</li>
                                    <li class="hashtag-list" v-if="kosiwon.options.use_sex_type === 'S'">#남녀층분리</li>
                                    <li class="hashtag-list" v-if="kosiwon.room_type && kosiwon.room_type.indexOf('M') >= 0">#미니룸</li>
                                    <li class="hashtag-list" v-if="kosiwon.room_type && kosiwon.room_type.indexOf('O') >= 0">#원룸</li>
                                    <li class="hashtag-list" v-if="kosiwon.room_type && kosiwon.room_type.indexOf('S') >= 0">#샤워룸</li>
                                    <li class="hashtag-list" v-if="kosiwon.options.option_aircon">#개별에어컨</li>
                                    <li class="hashtag-list" v-if="kosiwon.options.is_meal">#식사</li>
                                    <li class="hashtag-list" v-if="kosiwon.options.is_elevator">#엘리베이터</li>
                                    <li class="hashtag-list" v-if="kosiwon.options.is_parking">#주차</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import SampleImage from '@/assets/images/list-thumbnail-none.png'

import {
    mapState
} from 'vuex';

export default {
    props: ["kosiwonList"],
    data() {
        return {
            // H(휴식), M(마스터) 타입일 경우만 리본
            bestRibbonType: ["H", "M"]
        }
    },
    computed: {
        ...mapState({
            pickItem: state => state.INTEREST.PICK_LIST
        })
    },
    methods: {
        heartToggleKosiwon(kosiwon) {
            kosiwon.isHeart = !kosiwon.isHeart;

            const findKosiwon = this.pickItem.find(pick => {
                return pick.pk === kosiwon.pk
            });

            if (findKosiwon) {
                this.$store.dispatch('removePickList', kosiwon)
            } else {
                this.$store.dispatch('setPickList', kosiwon)
            }
            this.$forceUpdate();
        },
        packageTypeCheck(type) {
            return this.bestRibbonType.includes(type) ? true : false;
        },
        thumbnailCheck(url) {
            return url ? url : SampleImage;
        },
        getLineClassName(station_number) {
            const classList = [];

            let className;

            const subway_arr = station_number.split(",");

            for (let i = 0; i < subway_arr.length; i++) {
                switch (subway_arr[i]) {
                    case "인천1":
                        className = "incheon1";
                        break;
                    case "인천2":
                        className = "incheon2";
                        break;
                    case "분당":
                        className = "bundang";
                        break;
                    case "신분당":
                        className = "sinbundang";
                        break;
                    case "경의중앙":
                        className = "jungang";
                        break;
                    case "공항철도":
                        className = "airport";
                        break;
                    case "경춘":
                        className = "kyeongchun";
                        break;
                    case "의정부":
                        className = "uijeongbu";
                        break;
                    case "용인":
                        className = "yongin";
                        break;
                    case "경강":
                        className = "kyeonggang";
                        break;
                    case "우이신설":
                        className = "ui";
                        break;
                    case "서해":
                        className = "seohae";
                        break;
                    case "김포골드":
                        className = "gimpo";
                        break;
                    case "신림":
                        className = "sillim";
                        break;
                    default:
                        className = `line${subway_arr[i]}`
                        break;
                }
                classList.push(className);

                
            }
            // console.log(classList);
            return classList[0];
        }
    }
}
</script>
